module.exports = __webpack_public_path__ + "img/i4.bdb8b4d7.png";